<template>
    <div>
        <div class="row">
            <div class="form-group col-md-2">
                <label for="idInput">{{ $t('project.investment.form.id') }}*</label>
                <input maxlength="100" v-model.trim="investment.number" name="id" type="text" 
                    class="form-control" id="idInput" disabled readonly  /> 
            </div>

            <div class="form-group col-md-8">
                <label for="idInput">{{ $t('project.investment.form.project') }}*</label>
                
                <input type="hidden" name="project_validated" v-validate="'required'" v-model="project_validated" />

                <multiselect v-model="investment.project" id="ajax" open-direction="bottom" 
                    :options="projects" :multiple="false" :searchable="true" :loading="isLoading" 
                    :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                    :options-limit="300" :max-height="600" :show-no-results="true" 
                    :hide-selected="true" :taggable="false" :custom-label="projectLabel"
                    :placeholder="$t('project.investment.form.project')"
                    :select-label="$t('multiselect.select-label')"
                    @search-change="asyncProjectsFind" @select="onSelect">
                    <span slot="noResult">{{ $t('multiselect.not-found')}}.</span>
                </multiselect>

                <span class="text-danger" v-if="errors.has('project')">{{ errors.first('project') }}</span>
                <span class="text-danger" v-if="errors.has('project_validated')">{{ $t('validations.required') }}</span>
                
            </div>

            <div class="form-group col-md-2">
                <label for="regionInput">{{ $t('project.investment.form.region') }}*</label>
                <select v-model="investment.region" class="form-control" id="regionInput" >
                <option v-for="s in regions" :value="s.item1" :key="s.item1" >{{s.item2}}</option>
                </select>
            </div>

        </div>
            
        <slot name="project"></slot>

        <div class="row">
            <div class="form-group col-md-12">
                <div class="card">
                    <div class="card-header">
                        {{ $t('project.investment.form.history.title') }}

                        <div class="float-right" >
                            <a href="#processusAdd" name="processusAdd" @click="addProcessus"  v-if="compMode != CRUDMODE.READ">
                                <span class="fa fa-plus fa-lg"></span>
                            </a>
                            &nbsp;
                            <a href="#processus" name="processus" v-on:click="expandOrCollapseProcessus">
                                <span class="fa fa-expand fa-lg" v-if="!localVisibleProcessus" ></span>
                                <span class="fa fa-compress fa-lg" v-if="localVisibleProcessus"></span>
                            </a>
                        </div>
                    </div>
                    <div class="card-body" v-if="localVisibleProcessus">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="idInput">{{ $t('project.investment.form.user') }}</label>
                                <multiselect 
                                    id="user" 
                                    v-model="investment.user" 
                                    :customLabel="userSelectLabel"
                                    :options="userOptions" 
                                    :multiple="false" 
                                    :searchable="true" 
                                    :loading="isLoading" 
                                    :internal-search="true" 
                                    :clear-on-select="true" 
                                    :close-on-select="true" 
                                    :options-limit="10" 
                                    :limit="3" 
                                    :max-height="600" :allow-empty="false" :show-no-results="true" :hide-selected="true" 
                                    :placeholder="$t('project.investment.form.user')"
                                    v-bind:deselect-label="$t('multiselect.deselect-label')"
                                    v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                                    v-bind:select-label="$t('multiselect.select-label')"
                                    @search-change="usersAsyncFind"
                                    @select="onSelectUser">
                                    <span slot="noResult">{{ $t('multiselect.not-found')}}.</span>
                                </multiselect>
                                
                                <span class="text-danger" v-if="errors.has('associatedUser')">{{ errors.first('associatedUser') }}</span>
                            </div>

                            <div class="form-group col-md-3">
                                <label for="pressRelease">{{ $t('project.investment.form.pressRelease') }}</label>
                                <div class="col-9">
                                    <label class="custom-control custom-checkbox">
                                        <input type="checkbox" name="pressRelease" value="1" class="custom-control-input"  
                                        id="pressRelease" v-model="investment.pressRelease">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-label">{{$t("yes")}}</span>
                                    </label>
                                </div>
                            </div>
                            
                        </div>

                        <div class="row" v-if="investment.investmentProcessus != null && investment.investmentProcessus.length > 0" v-for="(processus, index) in investment.investmentProcessus">
                            <div class="form-group col-md-2">
                                <label for="pressRelease">{{ $t('project.investment.form.processus.type') }}</label>
                            
                                    <select v-model="processus.type" :data-vv-name="'type' + index"
                                        v-validate="'required'" class="form-control" id="typeInput" :placeholder="$t('project.investment.form.processus.type')">
                                        <option v-for="s in processusType" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                                    </select>
                                    <span class="text-danger" v-if="errors.has('reason'+ index)">{{ $t('validations.required') }}</span>
                            
                            </div>

                            <div class="form-group col-md-6" v-if="processus.type == null">

                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 1">
                                <label for="depositInput">{{ $t('project.investment.form.processus.deposit') }}</label>
                                <moment-date-picker v-model="processus.deposit"></moment-date-picker>
                            </div>
                            <div class="form-group col-md-2" v-if="processus.type == 1">
                                <label for="valueWantedInput">{{ $t('project.investment.form.processus.valueWanted') }}</label>
                                <input v-model.trim="processus.valueWanted" v-money="{}" name="valueWanted" type="text"
                                    class="form-control" id="valueWantedInput"  />
                                <span class="text-danger" v-if="errors.has('valueWanted')">{{ errors.first('valueWanted') }}</span>
                            </div>
                            <div class="form-group col-md-2" v-if="processus.type == 1">
                                <label for="initialMoneyInput">{{ $t('project.investment.form.processus.initialMoney') }}</label>
                                <input v-model.trim="processus.initialMoney" v-money="{}" name="initialMoney" type="text"
                                    class="form-control" id="initialMoneyInput" />
                                <span class="text-danger" v-if="errors.has('initialMoney')">{{ errors.first('initialMoney') }}</span>
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 2">
                                <label for="presentationInput">{{ $t('project.investment.form.processus.presentation') }}</label>
                                <moment-date-picker v-model="processus.presentation"></moment-date-picker>
                            </div>
                            <div class="form-group col-md-2" v-if="processus.type == 2"> 
                                <label for="numberOfInterestsInput">{{ $t('project.investment.form.processus.numberOfInterests') }}</label>
                                <input v-model.trim="processus.numberOfInterests" name="numberOfInterests" type="number" class="form-control" id="numberOfInterestsInput" 
                                    v-bind:placeholder="$t('project.investment.form.processus.numberOfInterests')"  />
                                <span class="text-danger" v-if="errors.has('numberOfInterests')">{{ errors.first('numberOfInterests') }}</span>
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 2"> 
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 3">
                                <label for="nextMeetingInput">{{ $t('project.investment.form.processus.nextMeeting') }}</label>
                                <moment-date-picker v-model="processus.nextMeeting"></moment-date-picker>
                            </div>
                            <div class="form-group col-md-2" v-if="processus.type == 3">
                                <label for="valueSearchedForAngelsInput">{{ $t('project.investment.form.processus.valueSearchedForAngels') }}</label>
                                <input v-model.trim="processus.valueSearchedForAngels" v-money="{}" name="valueSearchedForAngels" type="text"
                                    class="form-control" id="valueSearchedForAngelsInput"  />
                                <span class="text-danger" v-if="errors.has('valueSearchedForAngels')">{{ errors.first('valueSearchedForAngels') }}</span>
                            </div>
                            <div class="form-group col-md-2" v-if="processus.type == 3"> 
                            </div>
                            
                            <div class="form-group col-md-2" v-if="processus.type == 4">
                                <label for="signatureTSInput">{{ $t('project.investment.form.processus.signatureTS') }}</label>
                                <moment-date-picker v-model="processus.signatureTS"></moment-date-picker>
                            </div>
                            
                            <div class="form-group col-md-2" v-if="processus.type == 5">
                                <label for="debutVDInput">{{ $t('project.investment.form.processus.debutVD') }}</label>
                                <moment-date-picker v-model="processus.debutVD"></moment-date-picker>
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 6">
                                <label for="endVDInput">{{ $t('project.investment.form.processus.endVD') }}</label>
                                <moment-date-picker v-model="processus.endVD"></moment-date-picker>
                            </div>
                            

                            <div class="form-group col-md-2" v-if="processus.type == 7">
                                <label for="lastCallInput">{{ $t('project.investment.form.processus.lastCall') }}</label>
                                <moment-date-picker v-model="processus.lastCall"></moment-date-picker>
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 8">
                                <label for="appelInfoInput">{{ $t('project.investment.form.processus.appelInfo') }}</label>
                                <moment-date-picker v-model="processus.appelInfo"></moment-date-picker>
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 9">
                                <label for="endVDInput">{{ $t('project.investment.form.processus.rencontreInfo') }}</label>
                                <moment-date-picker v-model="processus.rencontreInfo"></moment-date-picker>
                            </div>
                            
                            <div class="form-group col-md-4" v-if="processus.type >= 4 && processus.type <= 9"> 
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type == 10">
                                <label for="abandonmentInput">{{ $t('project.investment.form.processus.abandonment') }}</label>
                                <moment-date-picker v-model="processus.abandonment"></moment-date-picker>
                            </div>
                            <div class="form-group col-md-2" v-if="processus.type == 10">
                                <label for="reasonInput">{{ $t('project.investment.form.processus.reason') }}</label>

                                <select v-model="processus.reason" class="form-control" id="reasonInput" >
                                    <option v-for="s in reasons" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                                </select>
                            </div>

                            <div class="form-group col-md-2" v-if="processus.type== 10"> 
                            </div>

                            <div class="form-group col-md-3">
                                <label for="idInput">{{ $t('project.investment.form.processus.comments') }}</label>
                                <input v-model.trim="processus.comment"  name="comment" 
                                    type="text" class="form-control" id="comment" :placeholder="$t('project.investment.form.processus.comments')" />
                            </div>
                            <div class="form-group col-md-1">
                                <div for="idInput">&nbsp;</div>
                                <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#processus" v-on:click="removeProcessus(index)">
                                    <span class="fa fa-lg fa-trash"></span>
                                </a>
                            </div>
                        
                        </div>
                    </div>

                        
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-md-12">
                <div class="card">
                    <div class="card-header">
                        {{ $t('project.investment.form.title') }}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label for="categoryInput">{{ $t('project.investment.form.category') }}*</label>
                                <input type="hidden" name="categoryInput_validate" v-model="categoryInput_validate" v-validate="'required'" />
                                <select v-model="investment.category" class="form-control" id="categoryInput" >
                                    <option v-for="s in categorys" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                                </select>
                                <span class="text-danger" v-if="errors.has('categoryInput_validate')">{{ $t('validations.required') }}.</span>
            
                            </div>
                            <div class="form-group col-md-2">
                                <label for="typeInput">{{ $t('project.investment.form.type') }}*</label>
                                <input type="hidden" name="type_validate" v-model="type_validate" v-validate="'required'" />
                                <select v-model="investment.type" class="form-control" id="typeInput" >
                                    <option v-for="s in types" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                                </select>
                                <span class="text-danger" v-if="errors.has('type_validate')">{{ $t('validations.required') }}.</span>
            
                            </div>
                            
                            <div class="form-group col-md-2">
                                <label for="dateOfInvestissementInput">{{ $t('project.investment.form.dateOfInvestissement') }}*</label>
                                <moment-date-picker v-model="investment.dateOfInvestissement" :required="true"></moment-date-picker>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-2">
                                <label for="totalValueAnges">{{ $t('project.investment.form.totalValueAnges') }}*</label>
                                <input  v-money="{}" name="totalValueAnges" type="text"
                                    class="form-control" id="totalValueAnges" :value="totalValueAnges" readonly="true" />
                            </div>
                            <div class="form-group col-md-2">
                                <label for="totalValueAngesJr">{{ $t('project.investment.form.totalValueAngesJr') }}*</label>
                                <input  v-money="{}" name="totalValueAngesJr" type="text"
                                    class="form-control" id="totalValueAngesJr" :value="totalValueAngesJr" readonly="true" />
                            </div>

                            <div class="form-group col-md-2">
                              <label for="aqcAmountInput">{{ $t('project.investment.form.aqcAmount') }}</label>
                              <input :value="totalValueAqc" v-money="{}" name="aqcAmount" type="text"
                                  class="form-control" id="aqcAmountInput" readonly="true" />
                            </div>

                            <div class="form-group col-md-2">
                                <label for="totalValuePartenaires">{{ $t('project.investment.form.totalValuePartenaires') }}*</label>
                                <input v-money="{}" name="totalValuePartenaires" type="text"
                                    class="form-control" id="totalValuePartenaires" :value="totalValuePartenaires" readonly="true" />
                            </div>
                            <div class="form-group col-md-1">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="totalValueInput">{{ $t('project.investment.form.totalValue') }}*</label>
                                <input :value="total" v-money="{}" name="totalValue" type="text" 
                                    class="form-control" id="totalValueInput" readonly="true" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-2">
                                <label for="totalQuantityAnges">{{ $t('project.investment.form.totalQuantityAnges') }}*</label>
                                <input name="totalQuantityAnges" type="text"
                                    class="form-control" id="totalQuantityAnges" :value="totalQuantityAnges" readonly="true" />
                            </div>
                            <div class="form-group col-md-2">
                                <label for="totalQuantityAngesJr">{{ $t('project.investment.form.totalQuantityAngesJr') }}*</label>
                                <input name="totalQuantityAngesJr" type="text"
                                    class="form-control" id="totalQuantityAngesJr" :value="totalQuantityAngesJr" readonly="true" />
                            </div>

                            <div class="form-group col-md-2">
                            </div>

                            <div class="form-group col-md-2">
                                <label for="totalQuantityPartenaires">{{ $t('project.investment.form.totalQuantityPartenaires') }}*</label>
                                <input name="totalQuantityPartenaires" type="text"
                                    class="form-control" id="totalQuantityPartenaires" :value="totalQuantityPartenaires" readonly="true" />
                            </div>

                            <div class="form-group col-md-1">
                            </div>

                            <div class="form-group col-md-3">
                                <label for="totalQuantity">{{ $t('project.investment.form.totalQuantity') }}*</label>
                                <input :value="totalQuantity" name="totalQuantity" type="text" 
                                    class="form-control" id="totalQuantityInput" readonly="true" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <investment-value :compMode="compMode" ref="investmentValues" :investmentValues="investment.investmentValues"></investment-value>

    </div>

</template>


<script>
import {
  InvestmentServiceClient,
  CompanyServiceClient,
  ProjectServiceClient,
  ProjectDto,
  EntrepriseDto,
  UserServiceClient,
  UserDto,
  CompanyInvestmentDto,
  InvestmentProcessDto,
  AddressServiceClient,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import MomentDatePicker from '../../shared/components/MomentDatePicker'
import Multiselect from 'vue-multiselect'
import InvestmentValue from './InvestmentValue'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'CreateInvestment',
  mixins: [CrudMixin],
  props: {
    investment: {
      type: Object,
    },
  },
  data() {
    return {
      investmentValues: [],
      reasons: [],
      types: [],
      categorys: [],
      projects: [],
      isLoading: false,
      userOptions: [],
      regions: [],
      processusType: [],
      localVisibleProcessus: true,
    }
  },
  inject: ['$validator'],
  mounted: function() {
    let self = this
    setTimeout(function() {
      self.fetchData()
      self.setMode()
    }, 1000)
  },
  computed: {
    project_validated: function() {
      if (this.investment.project != null) return this.investment.project.id
      else return null
    },
    categoryInput_validate: function() {
      return this.investment.category
    },
    type_validate: function() {
      return this.investment.type
    },
    totalValueAnges: function() {
      this.investment.amountAngels = _.sumBy(this.investment.investmentValues, function(x) {
        if (x.member != undefined && x.memberType !== 3 && x.memberStatus) {
          return parseInt(x.value)
        } else {
          return 0
        }
      })

      return this.investment.amountAngels
    },
    totalValueAngesJr: function() {
      this.investment.aqjAmount = _.sumBy(this.investment.investmentValues, function(x) {
        if (x.member != undefined && x.memberType === 3) {
          return parseInt(x.value)
        } else {
          return 0
        }
      })

      return this.investment.aqjAmount
    },
    totalValuePartenaires: function() {
      this.investment.amountPartners = _.sumBy(this.investment.investmentValues, function(x) {
        if ((x.partner != undefined && !x.partner.angesQuebecCapital) || (x.member != undefined && x.memberType !== 3 && !x.memberStatus)) {
          return parseInt(x.value)
        } else {
          return 0
        }
      })

      return this.investment.amountPartners
    },
    totalValueAqc: function() {
      this.investment.aqcAmount = _.sumBy(this.investment.investmentValues, function(x) {
        if (x.partner != undefined && x.partner.angesQuebecCapital) {
          return parseInt(x.value)
        } else {
          return 0
        }
      })

      return this.investment.aqcAmount
    },
    total: function() {
      return this.totalValueAnges + this.totalValueAngesJr + this.totalValuePartenaires + parseFloat(this.investment.aqcAmount)
    },
    totalQuantityAnges: function() {
      return (this.investment.quantityAngels = _(this.investment.investmentValues)
        .filter(x => x.member != undefined && x.memberType !== 3 && x.memberStatus)
        .size())
    },
    totalQuantityAngesJr: function() {
      return (this.investment.aqjQuantity = _(this.investment.investmentValues)
        .filter(x => x.member != undefined && x.memberType === 3)
        .size())
    },
    totalQuantityPartenaires: function() {
      return (this.investment.quantityPartners = _(this.investment.investmentValues)
        .filter(x => x.partner != undefined || (x.member != undefined && x.memberType !== 3 && !x.memberStatus))
        .size())
    },
    totalQuantity: function() {
      return this.totalQuantityAnges + this.totalQuantityAngesJr + this.totalQuantityPartenaires
    },
  },
  watch: {
    'investment.investmentValues': {
      handler: function(oldVal, newVal) {
        this.investment.totalValue = _.sumBy(this.investment.investmentValues, function(x) {
          return parseInt(x.value)
        })
      },
      deep: true,
    },
  },
  methods: {
    expandOrCollapseProcessus: function() {
      this.localVisibleProcessus = !this.localVisibleProcessus
    },
    addProcessus: function() {
      let dto = new InvestmentProcessDto()
      dto.init({})
      this.investment.investmentProcessus.push(dto)
    },
    removeProcessus: function(index) {
      this.investment.investmentProcessus.splice(index, 1)
    },
    fetchData: function() {
      let service = ServiceFactory.create(InvestmentServiceClient)
      let adressService = ServiceFactory.create(AddressServiceClient)

      let getReasons = service.getReasons()
      let getTypes = service.getTypes()
      let getCategorys = service.getCategorys()
      let getRegions = adressService.getRegions()
      let getInvestmentProcessType = service.getInvestmentProcessType()

      let self = this

      getReasons
        .then(res => {
          self.reasons = res
        })
        .catch(err => {
          console.log(err)
        })
      getTypes
        .then(res => {
          self.types = res
        })
        .catch(err => {
          console.log(err)
        })
      getCategorys
        .then(res => {
          self.categorys = res
        })
        .catch(err => {
          console.log(err)
        })
      getRegions
        .then(res => {
          self.regions = res
        })
        .catch(err => {
          console.log(err)
        })
      getInvestmentProcessType
        .then(res => {
          self.processusType = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    asyncProjectsFind: function(search) {
      this.isLoading = true
      let self = this
      let service

      if (this.investment.investmentType == 1) {
        service = ServiceFactory.create(CompanyServiceClient)
        service.getAutocomplete(1, search).then(response => {
          self.projects = response
          self.isLoading = false
        })
      } else {
        service = ServiceFactory.create(ProjectServiceClient)
        service.getAutocomplete(this.investment.investmentType, 1, search).then(response => {
          self.projects = response
          self.isLoading = false
        })
      }
    },
    onSelect: function(item) {
      this.$emit('projectSelected', item)
      this.investment.project = item
      this.investment.projectId = item.id
    },
    projectLabel: function(project) {
      return project.entreprise.name
    },

    usersAsyncFind: function(query) {
      this.isLoading = true
      let service = ServiceFactory.create(UserServiceClient)

      let self = this
      service.getAutocomplete(query).then(response => {
        self.userOptions = response
        self.isLoading = false
      })
    },
    userSelectLabel: function(option) {
      return option.id + ' - ' + option.firstName + ' ' + option.lastName
    },
    onSelectUser: function(user) {
      this.$emit('userSelected', user)

      this.investment.user = user
      this.investment.userId = user.id
    },
  },
  components: {
    Multiselect,
    InvestmentValue,
    Datepicker,
    'moment-date-picker': MomentDatePicker,
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Investment/CreateInvestment.vue